import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardHeader } from './CardHeader';
import { CardContainer, CardBody } from './Card.style';
export function Card({ variant = 'outlined', header, children, onClick, onMouseEnter, onMouseLeave, }) {
    return (_jsxs(CardContainer, { onClick: onClick, variant: variant, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: [header && (_jsx(CardHeader, Object.assign({}, header, { variant: variant, hasChildren: !!children }))), children && _jsx(CardBody, { children: children })] }));
}
//# sourceMappingURL=Card.js.map